import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="max-w-md mx-auto py-16 text-center">
      <h1 className="text-2xl font-serif mb-4">Seite nicht gefunden</h1>
      <p className="text-text-secondary mb-6">
        Die angeforderte Seite existiert nicht oder ist nicht verfugbar.
      </p>
      <Link to="/" className="btn-primary">Zur Startseite</Link>
    </div>
  );
}
